import React, { useCallback, useMemo } from "react";
import { AutoCompleteProps, Input, InputProps, RefSelectProps } from "antd";
import { DefaultOptionType } from "antd/es/select";

import { BaseAutocomplete } from "../BaseSelect";
import { RefCallBack } from "react-hook-form";

export interface InputWithAutocompleteProps extends AutoCompleteProps {
    selectTextOnFocus?: boolean;
    autocompleteList: string[];
    inputProps?: InputProps;
}

export const InputWithAutocomplete = function InputWithAutocomplete({
    ref: autocompleteRef,
    value,
    selectTextOnFocus,
    autocompleteList,
    inputProps,
    ...rest
}: InputWithAutocompleteProps & {
    ref?: React.RefObject<RefSelectProps> | RefCallBack;
}) {
    const options = useMemo(() => {
        return !value || value?.length < 3
            ? []
            : autocompleteList
                  .filter(v => v !== value) // value should be excluded, otherwise you will get [object Object] in the input
                  .map(option => ({
                      label: option,
                      value: option,
                  }));
    }, [autocompleteList, value]);

    const handleOnFocus = (e: React.FocusEvent<HTMLInputElement>) => {
        inputProps?.onFocus && inputProps.onFocus(e);
        if (selectTextOnFocus) {
            e.target.select();
        }
    };

    const filterListFn = useCallback((inputValue: string, option: DefaultOptionType) => {
        if (inputValue?.length < 3) {
            return false;
        }
        return option.value.toString().toLowerCase().includes(inputValue.toLowerCase());
    }, []);

    return (
        <BaseAutocomplete
            ref={autocompleteRef}
            styles={{ popup: { root: { maxWidth: 325 } } }}
            options={options}
            filterOption={filterListFn}
            value={value ? value.toString() : ""}
            {...rest}
        >
            <Input {...inputProps} onFocus={handleOnFocus} />
        </BaseAutocomplete>
    );
};
